import React from 'react';
import { Row } from 'react-bootstrap';
import { homeProducts } from 'helper/Home/homeProductsList';
import Product from './Product';

import './index.scss';

export default function ProductTable() {
  return (
    <Row className="product-row d-flex flex-row">
      {homeProducts.map((product) => (
        <Product key={product.id} product={product} />
      ))}
    </Row>
  );
}
